/**
 * @file Handle logout procedure
 *
 * It's not as simple as navigating to a logout route,
 * We need to clear IAM storage, cookie storage and Hotelboard API access token
 */

import { useMutation } from 'urql';

import { LogoutDocument } from '../generated/graphql';
import { reportError } from '../services/reporting';
import { logoutInIAM } from '../utils/auth';

/**
 * Make all the needed API requests to log out from Hotelboard
 *
 * @todo This should ideally use a beacon for a request,
 * but beacon cannot accept any headers, just type, so this is impossible atm
 * todo is left just in case in the future we find a better way to make a req to logout
 * and avoid a request wait time for the end user
 * @returns The callback to log the user out
 */
const useLogout = (): (() => void) => {
  const [, logoutMutation] = useMutation(LogoutDocument);
  return () => {
    logoutMutation({})
      .catch(error => reportError(error as string))
      .finally(logoutInIAM);
  };
};

export default useLogout;
